import React, { useState } from "react";
import { X } from "lucide-react";

const RejectionModal = ({ isOpen, onClose, onConfirm }) => {
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const rejectionReasons = [
    { value: "MISSING_DETAILS", label: "Missing Details" },
    { value: "EXPIRED_DOCUMENTS", label: "Expired Documents" },
    { value: "RESTRICT_ACCOUNT", label: "Restrict Account" },
    { value: "OTHER", label: "Other reason" },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!selectedReason) {
      newErrors.reason = "Please select a rejection reason";
    }

    if (selectedReason === "OTHER" && !customReason.trim()) {
      newErrors.customReason = "Please provide a reason for rejection";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onConfirm({
      reasonType: selectedReason,
      detail: selectedReason === "OTHER" ? customReason.trim() : null,
    });

    // Reset form
    setSelectedReason("");
    setCustomReason("");
    setErrors({});
  };

  const handleClose = () => {
    setSelectedReason("");
    setCustomReason("");
    setErrors({});
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-popinsSemiBold text-gray-900">
            Select Rejection Reason
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-4">
            <label
              htmlFor="rejectionReason"
              className="block text-sm font-popinsMedium text-gray-700 mb-2"
            >
              Select Reason for rejection
            </label>
            <select
              id="rejectionReason"
              value={selectedReason}
              onChange={(e) => {
                setSelectedReason(e.target.value);
                setErrors({ ...errors, reason: "" });
              }}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-themeColor ${
                errors.reason ? "border-red-500" : "border-gray-300"
              }`}
            >
              <option value="">Select Reason for rejection</option>
              {rejectionReasons.map((reason) => (
                <option key={reason.value} value={reason.value}>
                  {reason.label}
                </option>
              ))}
            </select>
            {errors.reason && (
              <p className="mt-1 text-sm text-red-600">{errors.reason}</p>
            )}
          </div>

          {selectedReason === "OTHER" && (
            <div className="mb-4">
              <label
                htmlFor="customReason"
                className="block text-sm font-popinsMedium text-gray-700 mb-2"
              >
                If any other reason
              </label>
              <textarea
                id="customReason"
                value={customReason}
                onChange={(e) => {
                  setCustomReason(e.target.value);
                  setErrors({ ...errors, customReason: "" });
                }}
                rows={4}
                placeholder="If any other reason"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-themeColor ${
                  errors.customReason ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.customReason && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.customReason}
                </p>
              )}
            </div>
          )}

          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-sm font-popinsMedium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex items-center gap-2 px-4 py-2 text-sm font-popinsSemiBold text-white bg-[#DD0000] rounded-md hover:bg-[#BB0000] transition-colors"
            >
              <X size={18} className="text-white" />
              Reject
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RejectionModal;

